import { Component } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserProfile } from '@models/UserProfile';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CognitoService } from './cognito.service';
import { SynchronizerService } from './synchronizer.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { CommonTasksService } from './common-tasks.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet,
    RouterModule,
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatSelectModule,
    MatMenuModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule],
  providers: [ /*provideHttpClient(withInterceptorsFromDi())*/]
})
export class AppComponent {
  public isDevEnvironment: boolean = false;

  constructor(public cognitoService: CognitoService,
    private synchronizerService: SynchronizerService,
    private router: Router,
    public commonTasks: CommonTasksService
  ) {
    this.isDevEnvironment = window.location.href.indexOf('dev.openreadersbibles.org') != -1;
    this.synchronizerService.initializeApplication();
  }

  get user(): UserProfile | undefined {
    return this.synchronizerService.user$.value;
  }

  login() {
    window.location.href = this.cognitoService.loginUrl;
  }

  logout() {
    this.synchronizerService.user$.next(undefined);
    localStorage.clear();
    this.router.navigate(['/']);
  }

}
